<template>
    <b-container fluid>
        <b-row>
            <b-col md="8"><h2>Group Business</h2></b-col>
            <b-col md="4">
                <b-button class="float-right" @click="exportGroup()">
                    <font-awesome-icon icon="file-csv"></font-awesome-icon>
                    Export All
                </b-button>
            </b-col>
            <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col md="6" class="my-1">
                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-table striped hover :items="items" :fields="fields"
                 :per-page="perPage" :current-page="currentPage"
                 :filter="filter"
                 title="Group"
                 @filtered="onFiltered">
            <template slot="tools" slot-scope="data">
                <div>
                    <b-button variant="primary" @click="enroll(data.item)"><font-awesome-icon icon="plus" class="mr-1"/>Enroll</b-button>
                    <b-button variant="success" @click="membership(data.item)">Membership</b-button>
                    <b-dropdown variant="primary" right text="">
                        <b-dropdown-item @click="generatePolicy(data.item)">Download Policy</b-dropdown-item>
                    </b-dropdown>
                </div>
            </template>
            <template slot="quickView" slot-scope="data">
                <font-awesome-icon icon="search" @click="data.toggleDetails"></font-awesome-icon>
            </template>
            <template slot="row-details" slot-scope="row">
                <b-card>
                    Underwriter: {{row.item.underwriter}}<br>
                    Group: {{row.item.group}}<br>
                    Name: {{row.item.name}}<br>
                    <div v-if="type==='producer'">
<!--                        commission value-->
                    </div>
                </b-card>
            </template>
            <template slot="products" slot-scope="data">
                <span v-for="product in data.item.pr_types">
                    <font-awesome-icon :icon="getIcon(product)" class="mr-1"
                                       v-b-popover.hover.top="getTitle(product)">

                    </font-awesome-icon>
                </span>
            </template>
        </b-table>
        <b-row>
            <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
            ></b-pagination>
        </b-row>
    </b-container>

</template>

<script>
    import config from '@/config/config'
    import axios from 'axios'

    export default {
        name: 'GroupList',
        props: ['items','type'],
        data () {
            return {
                perPage: 15,
                currentPage: 1,
                filter: null,
                pageOptions: [15, 35, 60, 100],
                fields: [
                    {
                        key: 'quickView',
                        sortable: false,
                        label: ''
                    },
                    {
                        key: 'underwriter',
                        sortable: true
                    },
                    {
                        key: 'group',
                        sortable: true
                    },
                    {
                        key: 'name',
                        sortable: true
                    },
                    {
                        key: 'products',
                        sortable: false
                    },
                    {
                        key: 'tools',
                        sortable: false
                    }
                ],
                termBox: '',
                hipaaBox: '',
                totalRows: 0
            }
        },
        methods: {
            exportGroup () {
                axios.get(config.apiUrl() + 'producer/getGroupExport', {}, {headers: {'Content-Type': 'arraybuffer'}}).then(response => {
                    let blob = new Blob([response.data], {type: 'octet-stream'})
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'group_export.csv'
                    link.click()
                })
            },
            getIcon (product) {
                switch (product) {
                    case 'MM':
                        return 'random'
                    case 'DE':
                        return 'tooth'
                    case 'RX':
                        return 'tooth'
                    case 'VI':
                        return 'eye'
                    case 'FX':
                        return 'random'
                    case 'WI':
                        return 'hospital'
                    case 'LT':
                        return 'blind'
                    case 'LA':
                        return 'life-ring'
                    case 'VL':
                        return 'life-ring'
                    case 'VC':
                        return 'child'
                    case 'VD':
                        return 'user-friends'
                    case 'DL':
                        return 'users'
                    case 'DI':
                        return 'hospital'
                    case 'CI':
                        return 'user-injured'
                    default:
                        return 'random'
                }
            },
            getTitle (product) {
                switch (product) {
                    case 'DE':
                        return 'Dental'
                    case 'RX':
                        return 'HMO Dental'
                    case 'DL':
                        return 'Dependent Life'
                    case 'VL':
                        return 'Voluntary Life'
                    case 'VC':
                        return 'Voluntary Child'
                    case 'VD':
                        return 'Voluntary Dependents'
                    case 'LA':
                        return 'Basic Life'
                    case 'VI':
                        return 'Vision'
                    case 'DI':
                        return 'Disability'
                    case 'WI':
                        return 'Short Term Disability'
                    case 'CI':
                        return 'Critical Illness'
                    case 'LT':
                        return 'Long Term Disability'
                    default:
                        return product
                }
            },
            onFiltered (filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            enroll (data) {
                this.$router.push('/dashboard/enroll/' + data.underwriter + data.group)
            },
            membership (data) {
                if (this.type === 'group-admin') {
                    this.$router.push('/dashboard/group-admin/group/' + data.underwriter + data.group)
                } else if (this.type === 'producer') {
                    this.$router.push('/dashboard/producer/group/' + data.underwriter + data.group)
                } else {
                    console.error('Unknown type');
                }
            },
            showTermBox (data) {
                this.termBox = ''
                this.$bvModal.msgBoxConfirm(
                    'Please confirm that you want to terminate ' + ' (' + data.item.cert + ') and dependents?', {
                        title: data.item.firstName + ' ' + data.item.lastName,
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                        if (value) {
                            let tempTermed = localStorage.getItem('tempTermed')
                            tempTermed = tempTermed ? tempTermed.split(',') : []
                            tempTermed.push(data.item.cert)
                            localStorage.setItem('tempTermed', tempTermed.toString())
                            this.items.splice(data.index, 1)
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
            generatePolicy(group) {
                axios.post(config.apiUrl() + 'group/policy', {group_code: group.underwriter + group.group, template: 'policy'}).then(response => {
                    this.$router.push('/dashboard/document/policy/' + response.data.hash);
                });
                // window.alert('Policy could not be generated. Please contact us for further assistance. (1)');
            }
        },
        mounted () {
            // Set the initial number of items
            this.totalRows = this.items.length
        }
    }
</script>

<style scoped></style>
